import React from 'react';
import Layout from '../layout/Layout';
import Package from './views/packages';

class PackagePage extends React.Component {
	render() {
		const { history, match } = this.props;
		return(
			<Layout history={history}>
                <main className="main-container">
                	<div className="main-content">
                        <Package history={history} match={match} />
                	</div>
                </main>
             </Layout>
		);
	}
}

export default PackagePage;
